<template>
    <Multiselect
        v-model="selected[select.label]"
        mode="tags"
        :searchable="true"
        :createTag="false"
        :options="options"
        @select="onSelect($event)"
        @deselect="onSelect($event)"
        @clear="onClear($event)">
        <template v-slot:tag="{ option, handleTagRemove }">
            <span class="multiselect-tag">                
                <label :for="option.label">
                    {{ option.label }}
                    <div class="color-input-wrapper">
                        <input class="color" type="color" :id="option.label" :name="option.label" :value="changeColors(`#${option.color}`)" @input="updateColor($event.target.value, option)">
                    </div>  
                </label>                                  
                <span class="multiselect-tag-remove" @mousedown.prevent="handleTagRemove(option, $event)">
                    <span class="multiselect-tag-remove-icon"></span>
                </span>
            </span>
        </template>
    </Multiselect>
</template>


<script>
import VisualisationService from '@/services/visualisation.service'
import SpacekitService from '@/services/spacekit.service'
import Multiselect from '@vueform/multiselect'

export default {
    name: "OrbitMultiselect",
    components: {
        Multiselect,
    },
    props: {
        select: Object
    },
    computed: {
        invertColors() {
            return VisualisationService.getInvertColors();
        },
    },
    data() {
        return {
            options: this.select.options ? VisualisationService.formatSelectOptions(this.select.options) : [],
            selected: {},
        };
    },
    methods: {
        onSelect(option) {
            const color = this.options.filter(e => e.value == option)[0].color;
            VisualisationService.selectOption(option, this.select.id, color);
            const multiselectOptions = VisualisationService.getMultiselectOptions();
            multiselectOptions[this.select.id] = [];
            multiselectOptions[this.select.id].push(this.options);
            VisualisationService.setMultiselectOptions(multiselectOptions);
        },
        onClear() {
            VisualisationService.clearSelectedOptions(this.select.id);
        },
        updateColor(color, option) {
            option.color = color.replace('#', '');
            let groupObjects = SpacekitService.getSmallObjectsGroup(this.select.id, option.value);
            VisualisationService.updateColorOption(this.select.id, option.value, option.color);

            const inv = (hex) => '#' + hex.match(/[a-f0-9]{2}/ig).map(e => (255 - parseInt(e, 16) | 0).toString(16).replace(/^([a-f0-9])$/, '0$1')).join('');
            
            if (VisualisationService.getInvertColors()){
                color = inv(color);
                option.color = color.replace('#', '');
                groupObjects = SpacekitService.getSmallObjectsGroup(this.select.id, option.value);
                VisualisationService.updateColorOption(this.select.id, option.value, option.color);
            }

            if (groupObjects) {
                SpacekitService.updateGroupColor(groupObjects, color);
            }                        
        },   
        changeColors(hex){
            const inv = (hex) => '#' + hex.match(/[a-f0-9]{2}/ig).map(e => (255 - parseInt(e, 16) | 0).toString(16).replace(/^([a-f0-9])$/, '0$1')).join('')          
            
            if (VisualisationService.getInvertColors()){
                return inv(hex);
            }else {
                return hex;
            }
        },    
    },
    mounted() {   
        if (VisualisationService.getOrbitVisualisationActiveSelects()){
            const selects = VisualisationService.getOrbitVisualisationSelects();
            this.selected[this.select.label] = [];
            for (const select in selects) {
                for (let i = 0; i < selects[select].length; i++){
                    let type, phrase, color;
                    type = select;
                    phrase = selects[select][i].option;
                    color = selects[select][i].color;
                    if (this.select.id === type ){
                        if (VisualisationService.getMultiselectOptions() && VisualisationService.getMultiselectOptions()[this.select.id])
                            this.options = VisualisationService.getMultiselectOptions()[this.select.id][0];
                        this.selected[this.select.label].push(phrase);
                    } 

                    //if (type && phrase && color) {
                    //    const selectType = type;
                    //    VisualisationService.getSmallobjectsData(selectType, phrase).then(smallObjects => SpacekitService.addSmallObjects(selectType, phrase, smallObjects, color));
                    //}
                    if (type && phrase && color) {
                        if (type === 'risk') {
                            VisualisationService.getSmallobjectsData(type, phrase)
                                .then(smallObjects => {
                                    // Step 1: Initialize empty arrays
                                    const dataE0 = [];
                                    const dataE1 = [];
                                    // Step 2: Loop through and split
                                    for (const obj of smallObjects) {
                                        if (obj.e > 0.9) {
                                            dataE1.push(obj);
                                        } else {
                                            dataE0.push(obj);
                                        }
                                    }
                                    // Step 3: Call SpacekitService with both sets
                                    SpacekitService.addSmallObjects(type, phrase, dataE0, dataE1, color);
                                });
                        } else {
                            const phrase1 = 'less_eccentric/' + phrase ;
                            const phrase2 = 'eccentric/' + phrase;

                            //console.log('In OrbitMultiSelect fetching data for:', phrase1, phrase2);
                            // Fetch both data sets in parallel
                            let dataE0 = [];
                            let dataE1 = [];
                            // Fetch both data sets in parallel
                            const promise1 = VisualisationService.getSmallobjectsData(type, phrase1).then(data => {
                                dataE0 = data || [];
                                return dataE0;
                            });
                            const promise2 = VisualisationService.getSmallobjectsData(type, phrase2).then(data => {
                                dataE1 = data || [];
                                return dataE1;
                            });
                            Promise.all([promise1, promise2])
                                .then(() => {
                                    SpacekitService.addSmallObjects(type, phrase, dataE0, dataE1, color);
                                })
                                .catch(error => {
                                    console.error('Error fetching data for phrases:', phrase1, phrase2, error);
                                });
                        }
                    }
                }
            }
        }

        if (!this.select.options) {            
            VisualisationService.getSmallobjectsData(this.select.id).then(options => this.options = options);            
        }
    }
};

</script>

<style lang="scss">
@import '@/styles/common/custom-select.scss';
</style>
